import React from 'react'
import { Col, Modal, Nav, Row, Tab } from 'react-bootstrap'

import ColumnChart from '@components/pages/Dashboard/Charts/ColumnChart.component'

import {
  colors,
  seriesNamesVisits,
  visitData,
} from '@components/pages/Dashboard/DashboardMockData'
import '../../../../pages/Dashboard/DashboardStyle.css'

type VisitsModalProps = {
  title: string
  isOpen: boolean
  toggleModal: () => void
}

function VisitsModal({
  title,
  isOpen,
  toggleModal,
}: VisitsModalProps): React.ReactElement {
  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      className="modal-fullscreen ar-aging-modal"
    >
      <Modal.Header className="bg-custom3 rounded-top" closeButton>
        <Modal.Title className="text-white">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <Row>
          <Col md={12} className="chart-tab visits-modal">
            <Tab.Container defaultActiveKey={'total'}>
              <Col md={12}>
                <Nav variant="pills" className="flex-row">
                  <Nav.Item key={`0`} className="">
                    <Nav.Link eventKey={'total'}>{'Total'}</Nav.Link>
                  </Nav.Item>
                  <Nav.Item key={`1`} className="">
                    <Nav.Link eventKey={'restorative'}>
                      {'Restorative'}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item key={`2`} className="">
                    <Nav.Link eventKey={'hygiene'}>{'Hygiene'}</Nav.Link>
                  </Nav.Item>
                  <Nav.Item key={`3`} className="">
                    <Nav.Link eventKey={'other'}>{'Other'}</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col md={12} className="mt-3">
                <Tab.Content>
                  <Tab.Pane eventKey={'total'}>
                    <Row>
                      <Col md={12} className="text-center">
                        <div className="fs-1 fw-bolder">Total production</div>
                        <div className="">
                          October 1, 2020 - October 08, 2023
                        </div>
                      </Col>
                      <Col md={12}>
                        <ColumnChart
                          title={'total-visits-modal'}
                          data={visitData}
                          seriesNames={seriesNamesVisits}
                          colors={colors}
                          legendSettings={{ visible: false }}
                          chartHeight={'450'}
                          chartWidth={'1200'}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey={'restorative'}>
                    <Row>
                      <Col md={12} className="text-center">
                        <div className="fs-1 fw-bolder">Restorative</div>
                        <div className="">
                          October 1, 2020 - October 08, 2023
                        </div>
                      </Col>
                      <Col md={12}>
                        <ColumnChart
                          title={'restorative-modal'}
                          data={visitData}
                          seriesNames={seriesNamesVisits}
                          colors={colors}
                          legendSettings={{ visible: false }}
                          chartHeight={'450'}
                          chartWidth={'1200'}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey={'hygiene'}>
                    <Row>
                      <Col md={12} className="text-center">
                        <div className="fs-1 fw-bolder">Hygiene</div>
                        <div className="">
                          October 1, 2020 - October 08, 2023
                        </div>
                      </Col>
                      <Col md={12}>
                        <ColumnChart
                          title={'hygiene-modal'}
                          data={visitData}
                          seriesNames={seriesNamesVisits}
                          colors={colors}
                          legendSettings={{ visible: false }}
                          chartHeight={'450'}
                          chartWidth={'1200'}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey={'other'}>
                    <Row>
                      <Col md={12} className="text-center">
                        <div className="fs-1 fw-bolder">Other</div>
                        <div className="">
                          October 1, 2020 - October 08, 2023
                        </div>
                      </Col>
                      <Col md={12}>
                        <ColumnChart
                          title={'other-modal'}
                          data={visitData}
                          seriesNames={seriesNamesVisits}
                          colors={colors}
                          legendSettings={{ visible: false }}
                          chartHeight={'450'}
                          chartWidth={'1200'}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Tab.Container>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default VisitsModal
